import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const adminLogin = (password) => api.post("/admin/login", { password }).then((r) => r.data);
export const adminVerify = (token) => api.get("/admin/verify", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const listLeads = (token) => api.get("/leads", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const updateLeadStatus = (token, id, status) =>
  api.patch(`/leads/${id}`, { status }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const deleteLead = (token, id) =>
  api.delete(`/leads/${id}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const adminMetrics = (token) =>
  api.get("/admin/metrics", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const investorLogin = (password) => api.post("/investor/login", { password }).then((r) => r.data);
export const investorVerify = (token) =>
  api.get("/investor/verify", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

// Booking (Planity-style)
export const getAvailability = (month) => api.get(`/availability?month=${month}`).then((r) => r.data);
export const createAppointment = (payload) => api.post("/appointments", payload).then((r) => r.data);
export const listAppointments = (token) =>
  api.get("/appointments", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const updateAppointmentStatus = (token, id, status) =>
  api.patch(`/appointments/${id}`, { status }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const deleteAppointment = (token, id) =>
  api.delete(`/appointments/${id}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const listBlockedDates = (token) =>
  api.get("/blocked-dates", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const addBlockedDate = (token, date, note) =>
  api.post("/blocked-dates", { date, note }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const removeBlockedDate = (token, id) =>
  api.delete(`/blocked-dates/${id}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const getSlotCapacity = () => api.get("/settings/slot-capacity").then((r) => r.data);
export const setSlotCapacity = (token, capacity) =>
  api.put("/settings/slot-capacity", { capacity }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const getPass = (code) => api.get(`/pass/${encodeURIComponent(code)}`).then((r) => r.data);
export const waConfirmAppointment = (id) => api.post(`/appointments/${id}/wa-confirm`).then((r) => r.data);

export const WHATSAPP_NUMBER = "+33786448247";
export const CALENDLY_URL = "https://calendly.com/riviera-shockwaves/vip";
